module.exports = __webpack_public_path__ + "static/media/CW.9294a989.svg";